export default __webpack_public_path__ + "static/media/logo.5889311f.jpg";